import React, { PropsWithChildren, useContext, useEffect, useState } from "react";
import { Outlet, useNavigate } from "react-router-dom"

import "./Workbench.scss";
// import { WorkbenchContext } from "./WorkbenchContext";
import { useAuth } from "react-oidc-context";
import axios from "axios";
import ProtectPage from "../components/layout/ProtectPage";
import Icon from "../components/icon/Icon";
import logOutSvg from "./assets/images/log-out-04.svg"
import AntdScheme from "../components/antd/AntdScheme";
import { Flex, Popover } from "antd";
import logoutSvg from "./assets/images/logout.svg"
import { LanguageSwitcher, useTranslate } from "../components/language";

// export interface WorkbenchProps{
//     menu: WorkbenchMenuItemProps[]
// }

export default (props: {onClose?: () => void}) => {

    // const [paths, setPaths] = useState<WorkbenchMenuItemProps[]>([])

    const navigate = useNavigate()

    const auth = useAuth();
    const { t } = useTranslate();

    switch (auth.activeNavigator) {
        case "signinSilent":
            return <div>{t('Signing you in...')}</div>;
        case "signoutRedirect":
            return <div>{t('Signing you out...')}</div>;
    }


    if (auth.isLoading) {
        return <div>{t('Loading...')}</div>;
    }

    if (auth.error) {
        return <div>{t('Oops...')} {auth.error.message}</div>;
    }
    
    if(!auth.isAuthenticated){
        auth.signinRedirect()
    }

    // 设置默认的 Authorization 头
    axios.defaults.headers.common["Authorization"] = `Bearer ${auth.user?.access_token}`;

    const getUserIcon = () => {
        if(auth.user?.profile){
            const email = auth.user?.profile.email
            //只取前两位，并且大写
            const name = email?.split("@")[0].substring(0, 2).toUpperCase() || "XX"
            return name
        }
    }

    const getUserEmail = () => {
        if(auth.user?.profile){
            const email = auth.user?.profile.email
            return email
        }
    }

    const logout = async () => {
        // await auth.removeUser();
        // auth.signoutRedirect({
        //     extraQueryParams: {
        //         client_id: auth.settings['client_id'],
        //         logout_uri: auth.settings['post_logout_redirect_uri'] as string,
        //     }
        // })
        // auth.signoutSilent({
        //     extraQueryParams: {
        //         client_id: auth.settings['client_id'],
        //         logout_uri: auth.settings['post_logout_redirect_uri'] as string,
        //     }
        // }).then(() => {
        //     //删除所有cookie
        //     document.cookie.split(";").forEach((c) => {
        //         document.cookie = c
        //             .replace(/^ +/, "")
        //             .replace(/=.*/, "=;expires=" + new Date().toUTCString() + ";path=/");
        //     });
        //     // auth.removeUser()
        // })
        // Clear local storage
        localStorage.clear();
        sessionStorage.clear();
        // await auth.removeUser()
        // navigate("/logout", {
        //     replace: true
        // })
        // auth.signinRedirect()
        
        // Redirect to Cognito logout endpoint
        const logout_uri =  auth.settings['post_logout_redirect_uri'] as string
        window.location.href = logout_uri
    }

    const goback = () => {
        navigate(-1)
    }

    const canGoBack = () => {
        return location.pathname !== "" && location.pathname !== "/app"
    }

    useEffect(() => {
        console.log("auth changed: ", auth)
    }, [auth])

    const ToolTip = (
        <Flex vertical align="center" className={'siderbar__toolbox'}>
            <div className={'siderbar__toolbox__tools'}>
                <div className={'siderbar__toolbox__profile'}>
                    <div className={'siderbar__toolbox__profile__name'}>{getUserEmail()}</div>
                    {/* <div className={'siderbar__toolbox__profile__email'}>{getUserEmail()}</div> */}
                </div>
                {/* <div className={'siderbar__toolbox__tools__divider'}></div> */}
            </div>
            
            <div className={'siderbar__toolbox__logout-wrapper'}>
                <Flex gap={8} align="center" className={'siderbar__toolbox__logout'}>
                    <Icon src={logoutSvg} size={16}></Icon>
                    <div style={{flex: 1}} className={'siderbar__toolbox__logout__label'} onClick={logout}>{t('Log out')}</div>
                </Flex>
            </div>
        </Flex>
    )

    return (
        <div className="workbench">
            <div className="header">
                <div className="l">
                    {canGoBack() && <Icon src={logOutSvg} size={24} onClick={goback}/>}
                    <span>{t('AI Translation Process')}</span>
                </div>
                <div className="header-controls">
                    <LanguageSwitcher />
                    <div className="profile">
                        <Popover placement="rightBottom" arrow={false} content={ToolTip}>
                            {getUserIcon()}
                        </Popover>
                    </div>
                </div>
            </div>
            <div className="body">
                <Outlet />
            </div>
        </div>
        
        
    )
}


